(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["am7-bundle-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am7-bundle-cards-v2')) {
    customElements.define('am7-bundle-cards-v2', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info');
        if (!this.scope) return;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
        this.schedule();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }
      setText(element, text) {
        if (element && element.textContent !== text) element.textContent = text;
      }
      sync() {
        const box = this.scope.querySelector('.moonbundle-box[data-bundle-id="25122817-1661-40a8-afc5-2eaf5d17e31f"]');
        if (!box) return;
        const ids = ['8fce2800-bd9b-457e-8097-0c69751bdae2', '9b69de3d-88bd-495a-9bb9-6117dd781d6a', '5901b662-84bd-4543-941e-8a3ae48e18fd'];
        // AM7 16/09/2026 : tolerant a la suppression d'une offre cote MoonBundle.
        // Avant, un seul offer-id manquant provoquait un return immediat et TOUT
        // le design custom des cartes disparaissait (retour au rendu MoonBundle
        // brut). On saute desormais les offres absentes au lieu d'abandonner.
        const entries = ids
          .map((id, index) => ({ index, wrapper: box.querySelector(`[data-offer-id="${id}"]`) }))
          .filter(entry => entry.wrapper && entry.wrapper.querySelector('.moonbundle-option'));
        if (!entries.length) return;
        if (!box.classList.contains('am7-bundle-cards')) box.classList.add('am7-bundle-cards');
        this.setText(box.querySelector(':scope > .moonbundle-title'), this.querySelector('[data-am7-heading]').content.textContent);
        this.setText(box.querySelector(':scope > .moonbundle-subtitle'), this.querySelector('[data-am7-subheading]').content.textContent);
        let note = box.querySelector('.am7-card-offer-note');
        if (!note) {
          note = document.createElement('div');
          note.className = 'am7-card-offer-note';
          note.setAttribute('aria-live', 'polite');
          box.querySelector('.moonbundle-options-horizontal').after(note);
        }
        const selectedEntry = entries.find(entry => entry.wrapper.querySelector('.moonbundle-option-active'));
        const selectedTemplate = selectedEntry ? this.querySelector(`[data-am7-card="${selectedEntry.index + 1}"]`) : null;
        const offerText = selectedTemplate?.dataset.text || '';
        this.setText(note, offerText);
        note.hidden = !offerText;
        entries.forEach(({ index, wrapper }) => {
          const template = this.querySelector(`[data-am7-card="${index + 1}"]`);
          if (!template) return;
          const option = wrapper.querySelector('.moonbundle-option');
          if (!option.querySelector('.am7-card-media')) option.prepend(template.content.cloneNode(true));
          const nativePrice = option.querySelector('.moonbundle-option-price');
          const total = nativePrice?.querySelector('.moonbundle-option-single-price');
          if (total?.textContent.trim()) {
            let prices = option.querySelector(':scope > .am7-card-prices');
            if (!prices) {
              prices = document.createElement('div');
              prices.className = 'am7-card-prices';
              for (const className of ['am7-card-was', 'am7-card-now', 'am7-card-unit']) {
                const span = document.createElement('span');
                span.className = className;
                prices.append(span);
              }
              option.append(prices);
            }
            this.setText(prices.querySelector('.am7-card-was'), nativePrice.querySelector('.moonbundle-option-old-price')?.textContent.trim() || '');
            this.setText(prices.querySelector('.am7-card-now'), total.textContent.trim());
            this.setText(prices.querySelector('.am7-card-unit'), nativePrice.querySelector('.moonbundle-option-each-price')?.textContent.trim() || '');
            nativePrice.style.setProperty('display', 'none', 'important');
          }

          this.setText(option.querySelector('.moonbundle-option-title span'), template.dataset.title);
          this.setText(option.querySelector('.moonbundle-option-subtitle'), template.dataset.text);
          let badge = wrapper.querySelector('.am7-card-badge');
          if (!badge && template.dataset.badge) {
            badge = document.createElement('span');
            badge.className = 'am7-card-badge';
            wrapper.append(badge);
          }
          if (badge) {
            this.setText(badge, template.dataset.badge);
            badge.hidden = !template.dataset.badge;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
